import type { GroupedTechnologiesCategoryMap } from "app/pages/sales-intelligence/modules/technology/types/technologies";
import type {
    TechColumnName,
    TechColumnType,
} from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import { ColumnType } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { createTechColumnName } from "../misc";

const getTechnologyColumnType = (
    technology: string,
    { categories, subCategories }: GroupedTechnologiesCategoryMap,
): TechColumnType => {
    switch (true) {
        case categories.has(technology):
            return ColumnType.TechCategory;
        case subCategories.has(technology):
            return ColumnType.TechSubCategory;
        default:
            return ColumnType.Tech;
    }
};

const checkIfTechnologiesOfOneCategory = (
    category: string,
    technologies: readonly string[],
    technologiesOptions: GroupedTechnologiesCategoryMap["technologies"],
): boolean => {
    return !technologies.some((technology) => {
        const categoryOrSubCategory = technologiesOptions.get(technology);

        if (is.undefined(categoryOrSubCategory)) {
            return false;
        }

        return category !== categoryOrSubCategory;
    });
};

export const getTechnologiesColumnName = (
    technologies: readonly string[],
    technologiesCategoryMap: GroupedTechnologiesCategoryMap,
): TechColumnName | null => {
    const referenceCategoryOrSubCategory = technologiesCategoryMap.technologies.get(technologies[0]);

    if (is.undefined(referenceCategoryOrSubCategory)) {
        return null;
    }

    const areTechnologiesOfOneCategory = checkIfTechnologiesOfOneCategory(
        referenceCategoryOrSubCategory,
        technologies,
        technologiesCategoryMap.technologies,
    );

    if (areTechnologiesOfOneCategory) {
        const columnType = getTechnologyColumnType(referenceCategoryOrSubCategory, technologiesCategoryMap);

        return createTechColumnName(columnType, referenceCategoryOrSubCategory);
    }

    return null;
};
